import React, { Component } from 'react';
import inuit from '../../config/inuitConfig';
import { fetchWithAuth } from '../../../utils/apiHelpers';
import MenuItemSide from '../../sidebar/menuItem';
import { FaDatabase } from 'react-icons/fa';
import { Flex } from '@chakra-ui/react';
import MenuItemDropdown from '../../sidebar/menuItemDropdown';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

class MenuSideBar extends Component {
  state = {
    screens: [],
    dashboard: true,
    cost: false,
    benchmark: false,
    task: false,
    setting: false,
    budget: false,
    upload: false,
    excelDat: false,
    financialAnalysis: false,
    aiSummary: false,
    activeBtn: 'dashboard',

    clickThruScreen: this.props.clickThruScreen,
  };

  handleAuth = async () => {
    var data = new FormData();
    data.append('client_id', this.state.client_id);
    data.append('secret_key', this.state.secret_key);
    data.append('inuit_company_id', this.state.inuit_company_id);
    data.append('type', inuit['type']);

    fetchWithAuth('/api/inuit_auth/', {
      method: 'POST',
      body: data,
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.redirect(data);
      })
      .catch(err => {
        console.error(err);
        alert('Error occurred.');
      });
  };

  redirect = async url => {
    this.setState({ modalButtonLoading: false, modalOpen: false });
    try {
      const { redirectToIntuitOAuth } = await import(
        '../../../utils/intuitSessionUtils'
      );
      redirectToIntuitOAuth(url);
    } catch (_e) {
      // Fallback: open directly if dynamic import fails
      window.location.href = url;
    }
  };

  objToJson = (key, value) => {
    var res = {};
    res[key] = value;
    console.log(res);
    return res;
  };

  disableAll = () => {
    this.setState({
      dashboard: false,
      cost: false,
      benchmark: false,
      task: false,
      setting: false,
      budget: false,
      upload: false,
      excelDat: false,
      financialAnalysis: false,
      aiSummary: false,
    });
  };

  getActiveScreen = screen => {
    const obj = this.state.screens.find(
      ob => ob.name === this.state.clickThruScreen
    );
    var screenName = '';
    if (screen['key'] === this.props.clickThruScreen && obj !== undefined) {
      screenName = this.props.clickThruScreen;
      this.disableAll();
      this.setState(this.objToJson(screenName, true));
    }
  };
  onClickFunc = (screen, active_button) => {
    console.log(active_button);
    // Save active button to state
    this.setState({ activeBtn: active_button });
    // Save active button to localStorage
    localStorage.setItem('activeBtn', active_button);

    if (typeof this.props.handleVisibleScreen === 'function') {
      this.props.handleVisibleScreen(screen?.description); // Send screen key to Dashboard
    }
    const authFlag = this.state.screens.includes(this.props.clickThruScreen);
    const screenName = authFlag ? this.props.clickThruScreen : screen['key'];

    window.scrollTo(0, 0);
    this.disableAll();
    this.setState(this.objToJson(active_button, true));
    this.props.onClick(screenName);
    this.props.clickEvent(true);
  };

  componentDidMount = () => {
    // Clear localStorage when the page is refreshed
    window.onbeforeunload = () => {
      localStorage.removeItem('activeBtn');
    };

    fetchWithAuth('/api/screens/', {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === undefined) {
          this.setState({ screens: data['screen_list'] });

          // Retrieve activeBtn from localStorage (if it exists)
          const activeBtn = localStorage.getItem('activeBtn');
          if (activeBtn) {
            this.setState({ activeBtn: activeBtn });
          }
        } else {
          window.open('/login', '_self');
          alert('Session Expired!.');
        }
      })
      .catch(err => console.log(err));
  };

  render() {
    return (
      <>
        <Flex
          direction="column"
          mt={2}
          align="center"
          gap={3}
          p={this.props.padding}
          pt={1}
          height="100%" // Ensure the Flex container takes full height
          overflowY="auto" // Enables scrolling
          boxSizing="border-box"
          css={{
            '&::-webkit-scrollbar': { width: '8px' }, // Custom scrollbar for better UX
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#fae3a0',
              borderRadius: '10px',
            },
          }}
        >
          {this.state.screens ? (
            // Process the screens array to handle budget items
            (() => {
              const showReskin =
                this.props.flags && this.props.flags.showReskin;
              const slimFeaturesOnly =
                this.props.flags && this.props.flags.slimFeaturesOnly;

              // Only apply slimFeaturesOnly if showReskin is true
              const shouldApplySlimFeatures = showReskin && slimFeaturesOnly;

              // Filter out all budget-related items if shouldApplySlimFeatures is true
              let processedScreens = this.state.screens;
              if (shouldApplySlimFeatures) {
                // Remove all budget-related screens when slimFeaturesOnly is true and showReskin is true
                processedScreens = processedScreens.filter(
                  screen =>
                    screen.key !== 'budget' &&
                    screen.key !== 'budgetDashboard' &&
                    !screen.key.toLowerCase().includes('budget')
                );
              }
              // No transformation of budget item names to uppercase

              return processedScreens;
            })().map(screen => (
              <MenuItemSide
                key={screen.key}
                sidebarCollapse={this.props.sidebarCollapse}
                icon={FaDatabase}
                //menuName={screen['key']}
                menuObj={screen}
                onClick={(value, active_button) => {
                  this.onClickFunc(value, active_button);
                }}
                active={
                  screen.child.length > 0
                    ? this.state.activeBtn === screen['key']
                    : screen['key'] === this.props.view
                }
              />
            ))
          ) : (
            <></>
          )}
          {/*
                    <MenuItemDropdown
                        sidebarCollapse={this.props.sidebar}
                        menuName={'Financial Insights Test'}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            this.disableAll('Comparator');
                            this.setState(this.objToJson('Comparator', true))
                            this.props.onClick('Comparator');
                            this.props.clickEvent(true)

                        }}
                        active={this.props.clickThruScreen!==null?false:this.state['Comparator']}
                    />

                   <MenuItemSide
                        sidebarCollapse={this.props.sidebar}
                        menuName={'Excel Data'}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            this.disableAll('excelData');
                            this.setState(this.objToJson('ExcelDat', true))
                            this.props.onClick('ExcelDat');
                            this.props.clickEvent(true)

                        }}
                        active={this.state['ExcelDat']}
                    />
                    <MenuItemSide
                        sidebarCollapse={this.props.sidebar}
                        menuName={'Setting'}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            this.disableAll('Setting');
                            this.setState(this.objToJson('Setting', true))
                            this.props.onClick('Setting');
                            this.props.clickEvent(true)
                        }}
                        active={this.state['Setting']}

                    /> */}
        </Flex>
      </>
    );
  }
}

// Wrap the component with the LaunchDarkly consumer to access feature flags
export default withLDConsumer()(MenuSideBar);
